type ProductFruitsUser = {
  login?: string;
};

declare global {
  interface Window {
    $productFruits?: {
    push: (args: any[]) => void;
    };
  }
}

export function InicializarProductFruits({
  login,
}: ProductFruitsUser) {
  const WorksPaceID = process.env.REACT_APP_PRODUCT_FRUITS_WORKSPACE_ID;

  if (window.$productFruits) {
    window.$productFruits.push([
      'init',
      WorksPaceID,
      'pt',
      {
        username: login,
      },
    ]);
  } else {
    console.warn('Product Fruits não foi carregado.');
  }
}

